/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TheCargo Loadboard
 * Bridges TheCargo platform with third-party freight loadboards — Central Dispatch and Super Dispatch — for posting, listing, and synchronizing vehicle transport orders.

## Authentication

All endpoints require a JWT Bearer token:
```
Authorization: Bearer <access_token>
```

Obtain tokens via the **Auth Service** (`POST /auth/api/v1/auth/login`).

## Loadboard Accounts

Each organization may connect one or more loadboard accounts. Credentials are stored encrypted; outbound sync runs on a schedule plus on-demand triggers.

## Webhooks

Inbound webhook endpoints accept callbacks from external loadboards and emit internal RabbitMQ events that the shipment service consumes.

## Contact

For API access or issues contact **support@thecargo.io**
 * OpenAPI spec version: 1.0.0
 */

export type CDBalancePaymentMethod =
  (typeof CDBalancePaymentMethod)[keyof typeof CDBalancePaymentMethod]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CDBalancePaymentMethod = {
  CASH: 'CASH',
  CERTIFIED_FUNDS: 'CERTIFIED_FUNDS',
  COMPANY_CHECK: 'COMPANY_CHECK',
  COMCHEK: 'COMCHEK',
  TCH: 'TCH',
} as const
